import { InstrumentDetailFullOut } from 'src/app/services/rest-api/rest-api';

export interface LineChartCoordinates {
  x: number | Date,
  y: number,
}

export interface DevelopmentChartData {
  optimisticScenario: LineChartCoordinates[],
  probableScenario: LineChartCoordinates[],
  pessimisticScenario: LineChartCoordinates[],
  deposits: LineChartCoordinates[]
}

export interface ModelStrategyOut {
  modelStrategyId: number,
  name: string,
  description: string,
  imageUrl: string,
  iconUrl: string,

  // todo - swagger contained these but Gets all model strategies without instruments
  // instruments: ModelStrategyInstrumentOut[],
}

// missing keys from API
export interface ModelStrategyCardInput extends ModelStrategyOut {
  profitPercentage: number;
  period: string;
}

export interface ModelStrategyInstrumentOut {
  instrument: InstrumentDetailFullOut,
  weight: number,
}

export interface InstrumentOut {
  instrumentId: number,
  isin: string,
  currencyCode: string,
}

export interface InstrumentChartCardInput {
  id: number,
  chartData: ModelStrategyInstrumentOut[],
}

export enum CurrencyCodesEnum {
  CZK = 'CZK',
  EUR = 'EUR',
}

export const DEFAULT_CURRENCY = CurrencyCodesEnum.CZK;

export enum LanguagesEnum {
  'cs-CZ' = 'cs-CZ',
  'en-GB' = 'en-GB',
}

export type EsgTypes = 'AAA' | 'AA' | 'A' | 'BBB' | 'BB' | 'B' | 'CCC';
export type IncomeTypes = 'DISTRIBUTING' | 'ACCUMULATING';
export type InstrumentTypes = 'ETF' | 'OPF';
export type InstrumentTargets = 'REGIONAL' | 'THEMATIC' | 'SECTORAL';

export interface FormInstrument {
  description: string,
  id: number
  name: string,
  value: number
  isin: string,
}

export interface ConditionControl {
  name: InstrumentDetailFullOut['instrumentCategory'],
  value: boolean,
}

export enum InstrumentCategories {
  EQUITY = 'EQUITY',
  BOND = 'BOND',
  ALTERNATIVE = 'ALTERNATIVE',
  COMODITY = 'COMODITY',
  MONEY = 'MONEY',
  CASH = 'CASH',
  REAL_ESTATE = 'REAL_ESTATE',
  LEVERAGED = 'LEVERAGED',
  CRYPTOCURRENCY = 'CRYPTOCURRENCY',
  MULTI_ASSET = 'MULTI_ASSET',
}
